import React, { useState, useRef, useEffect } from "react";

const YearSelector = ({ selectedYear, onYearChange, yearRange = 10 }) => {
  const [yearDropdownOpen, setYearDropdownOpen] = useState(false);
  const yearRef = useRef(null);

  // Generate year options dynamically based on SELECTED year
  const baseYear = selectedYear ? parseInt(selectedYear) : new Date().getFullYear();
  const yearsBeforeAfter = Math.floor(yearRange / 2);
  const startYear = baseYear - yearsBeforeAfter;
  const endYear = baseYear + yearsBeforeAfter;

  // Generate array of years centered around selected year
  const years = Array.from({ length: yearRange + 1 }, (_, i) => startYear + i);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (yearRef.current && !yearRef.current.contains(event.target)) {
        setYearDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={yearRef}
      className="d-flex align-items-center gap-1"
      style={{
        borderRadius: "8px",
        padding: "4px 12px",
        backgroundColor: "#ffffff",
        position: "relative",
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7157C2" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>

      <div onClick={() => setYearDropdownOpen(!yearDropdownOpen)} style={{ position: "relative", cursor: "pointer", userSelect: "none" }}>
        <div
          style={{
            fontSize: "14px",
            color: "#7157C2",
            fontWeight: "500",
            paddingRight: "20px",
          }}
        >
          {selectedYear}
        </div>
        {/* Dropdown Arrow */}
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          style={{
            position: "absolute",
            right: "0",
            top: "50%",
            transform: yearDropdownOpen ? "translateY(-50%) rotate(180deg)" : "translateY(-50%)",
            transition: "transform 0.2s ease",
          }}
        >
          <path d="M1 1L6 6L11 1" stroke="#7157C2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Dropdown Menu */}
      {yearDropdownOpen && (
        <div
          className="custom-dropdown-menu"
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: "0",
            backgroundColor: "#ffffff",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            minWidth: "90px",
            maxHeight: "250px",
            overflowY: "auto",
            padding: "8px 0",
          }}
        >
          {years.map((year) => (
            <div
              key={year}
              onClick={() => {
                onYearChange(year.toString());
                setYearDropdownOpen(false);
              }}
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                color: selectedYear === year.toString() ? "#7157C2" : "#21272c",
                backgroundColor: selectedYear === year.toString() ? "#f0f5ff" : "transparent",
                cursor: "pointer",
                fontWeight: selectedYear === year.toString() ? "600" : "400",
                transition: "background-color 0.15s ease",
              }}
              onMouseEnter={(e) => {
                if (selectedYear !== year.toString()) {
                  e.target.style.backgroundColor = "#f8f9fa";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedYear !== year.toString()) {
                  e.target.style.backgroundColor = "transparent";
                }
              }}
            >
              {year}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default YearSelector;
